<template>
  <div>
    <div class="row">
      <div class="col-8">
        <div class="homepage__filters">
          <label>
            <input
              class="input-radio"
              name="filter"
              type="radio"
              value="ALL"
              v-model.number="selectedStatus"
            />
            All
          </label>
          <label>
            <input
              class="input-radio"
              name="filter"
              type="radio"
              value="INPROGRESS"
              v-model.number="selectedStatus"
            />
            In progress
          </label>
          <label>
            <input
              class="input-radio"
              name="filter"
              type="radio"
              value="RELEASED"
              v-model.number="selectedStatus"
            />
            Released
          </label>
          <label>
            <input
              class="input-radio"
              name="filter"
              type="radio"
              value="REJECTED"
              v-model.number="selectedStatus"
            />
            Rejected
          </label>
        </div>
      </div>
      <div class="col-4">
        <v-select
          v-model="selectedReasons"
          :disabled="reasonDisabled"
          :items="reasons"
          label="All reasons"
          solo
          dense
          multiple
        ></v-select>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :items="batches"
      :sort-by="'createdAt'"
      :sort-desc="true"
      item-key="id"
      dense
      class="table"
      @click:row="goToBatch"
    >
      <template v-slot:item.status="{ item }">
        <span>{{ item.status }} </span>
        <span v-if="item.reasons && item.reasons.length"
          >({{ item.reasons.join(", ") }})</span
        >
      </template>
      <template v-slot:item.createdAt="{ item }">
        <span>{{ item.createdAt.toDate().toLocaleString() }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import firebase from "firebase/app";
import _map from "lodash/map";

const headers = [
  { text: "Batch ID", value: "id" },
  { text: "Date", value: "createdAt" },
  { text: "Status", value: "status" },
  { text: "Tester", value: "tester" }
];

const reasons = [
  { text: "Dino Active Area", value: "dino-active-area" },
  { text: "Dino Active Area Location ", value: "dino-active-area-location" },
  { text: "Blank Spectrum", value: "blank-spectrum" },
  { text: "Reference Spectrum", value: "reference-spectrum" }
];

export default {
  data() {
    return {
      batches: [],
      headers,
      reasons,
      selectedReasons: [],
      selectedStatus: "ALL"
    };
  },

  async created() {
    try {
      await this.getBatches();
    } catch (err) {
      console.log(err);
    }
  },

  watch: {
    async selectedStatus(value) {
      if (value !== "REJECTED") {
        this.selectedReasons = [];
      }

      try {
        await this.getBatches();
      } catch (err) {
        console.log(err);
      }
    },

    async selectedReasons() {
      try {
        await this.getBatches();
      } catch (err) {
        console.log(err);
      }
    }
  },

  computed: {
    reasonDisabled() {
      return this.selectedStatus !== "REJECTED";
    }
  },

  methods: {
    goToBatch(row) {
      this.$router.push({ name: "Batch", params: { batchId: row.id } });
    },
    async getBatches() {
      const db = firebase.firestore();

      try {
        let query = db.collection("batches");
        if (this.selectedStatus !== "ALL") {
          query = query.where("status", "==", this.selectedStatus);
        }
        if (this.selectedReasons.length) {
          query = query.where(
            "reasons",
            "array-contains-any",
            this.selectedReasons
          );
        }
        const snapshot = await query.orderBy("createdAt", "desc").get();

        this.batches = _map(snapshot.docs, doc => ({
          doc: doc.id,
          ...doc.data()
        }));
      } catch (err) {
        console.log(err);
      }
    },
    async setFilter(value) {
      this.filter = value;
      this.getBatches();
    }
  }
};
</script>
